/* ===========================
   Tagacutie Redesign
   Custom JavaScript
   =========================== */

document.addEventListener('DOMContentLoaded', function () {

  // Header Sticky Logic
  const header = document.querySelector('.h-area');
  if (header) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 50) {
        header.classList.add('is-sticky');
      } else {
        header.classList.remove('is-sticky');
      }
    });
  }

  // Mobile Menu Toggle
  const mobileToggle = document.querySelector('.tag-mobile-toggle');
  const navMenu = document.querySelector('.menu-area');

  if (mobileToggle && navMenu) {
    mobileToggle.addEventListener('click', () => {
      navMenu.classList.toggle('is-open');
    });
  }

  // Testimonial Slider Logic
  const testimonialSliders = document.querySelectorAll('.tag-testimonials-slider');


  testimonialSliders.forEach(slider => {
    const wrapper = slider.parentElement;
    const prevBtn = wrapper.querySelector('.tag-prev');
    const nextBtn = wrapper.querySelector('.tag-next');
    const cards = slider.querySelectorAll('.tag-testimonial-card');

    let autoPlayInterval;

    if (!slider || cards.length === 0) return;

    const getScrollStep = () => {
  return slider.clientWidth;
};

    const startAutoPlay = () => {
      if (cards.length <= 1) return;
      stopAutoPlay();
      autoPlayInterval = setInterval(() => {
        const step = getScrollStep();
        const maxScroll = slider.scrollWidth - slider.clientWidth;
        
        // Looping/Rewind Logic
        if (slider.scrollLeft >= maxScroll - 10) {
          slider.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          slider.scrollBy({ left: step, behavior: 'smooth' });
        }
      }, 5000); // 5s Autoplay
    };

    const stopAutoPlay = () => clearInterval(autoPlayInterval);

    if (prevBtn && nextBtn) {
      prevBtn.addEventListener('click', () => {
        const step = getScrollStep();
        if (slider.scrollLeft <= 10) {
          // At start, loop to end
          const maxScroll = slider.scrollWidth - slider.clientWidth;
          slider.scrollTo({ left: maxScroll, behavior: 'smooth' });
        } else {
          slider.scrollBy({ left: -step, behavior: 'smooth' });
        }
        startAutoPlay(); // Reset timer
      });
      
      nextBtn.addEventListener('click', () => {
        const step = getScrollStep();
        const maxScroll = slider.scrollWidth - slider.clientWidth;
        if (slider.scrollLeft >= maxScroll - 10) {
          // At end, loop to start
          slider.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          slider.scrollBy({ left: step, behavior: 'smooth' });
        }
        startAutoPlay(); // Reset timer
      });
    }

    startAutoPlay();
    
    // Pause on hover
    slider.addEventListener('mouseenter', stopAutoPlay);
    slider.addEventListener('mouseleave', startAutoPlay);
  });

});
